<div class="h-full w-full flex flex-col overflow-hidden">
    <div
        class="w-full flex-1 overflow-hidden flex flex-col gap-y-4 items-center justify-start">
        <div
            class="h-full w-full max-w-4xl mx-auto flex flex-col gap-y-4 py-6 sm:py-8 overflow-y-auto scrollbar-transparent">

            <h2
                class="mx-auto text-2xl font-semibold tracking-tight text-balance text-primary sm:text-4xl md:text-5xl text-center sm:text-left use-grotesque">
                Meet your
                <span class="bg-gradient-to-r from-primary to-brand-studio bg-clip-text text-transparent">recommended
                    creators</span>

            </h2>
            <p class="mx-auto mt-2 max-w-xl text-base sm:text-lg/8 text-pretty text-secondary text-center sm:text-left">
                AI-matched based on your brand, brief, and campaign goals</p>


            <div class="flex flex-row items-center justify-center gap-x-2 mx-auto mt-6 text-primary">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path
                        d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" />
                </svg>

                <p class="max-w-2xl text-base sm:text-lg/8 text-pretty text-primary text-center sm:text-left">Found {{
                    magicSearchService.goldOnboardingSearchResults()?.meta?.total }} creators with relevant content</p>
            </div>


            @for (result of (magicSearchService.goldOnboardingSearchResults()?.results?.slice(0,10) ?? []); track
            $index) {
            <v2-recommended-creator-item [creatorResult]="result"></v2-recommended-creator-item>
            }
            @empty {
            <div class="flex flex-col items-center justify-center px-6 py-12 text-center">
                <div class="flex items-center justify-center size-14 rounded-2xl bg-zinc-100 dark:bg-zinc-800/60 mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-7 text-zinc-400 dark:text-zinc-500">
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                        <circle cx="9" cy="7" r="4" />
                        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                </div>
                <h3 class="text-sm font-semibold text-primary">No creators found</h3>
                <p class="mt-1 text-xs text-secondary max-w-[200px]">No AI-matched creators were found for this brief.
                    You can invite creators manually later.</p>
            </div>
            }
        </div>

    </div>
    <div class="w-full shrink-0 p-4 flex flex-col gap-y-2">
        <div class="w-full flex flex-row items-center gap-x-2 mt-2">
            <button type="button" (click)="creatorsSelected()"
                class="w-3/4 mx-auto text-center primary-go-button flex flex-row items-center gap-x-4 justify-center rounded-md px-4 py-3 sm:py-1.5 text-base sm:text-sm font-semibold min-h-11 touch-manipulation">

                <p class="block">Let's go!</p>

                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5 shrink-0">
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                </svg>

            </button>
        </div>

        <div class="w-3/4 flex flex-row items-center gap-x-2 mt-2 mx-auto">
            <p class="text-sm text-secondary text-center mx-auto">You can find and invite more creators and manage your
                creators
                for this (and all) briefs later.</p>
        </div>
    </div>
</div>